// extracted by mini-css-extract-plugin
export default {"menu-list-multi":"MenuListMulti_menu-list-multi__kfMMi","all-checkbox":"MenuListMulti_all-checkbox__wcfls","selected":"MenuListMulti_selected__iA52X"};